import React, { FC } from 'react'
import Drawer from '@mui/material/Drawer'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import CircularProgress from '@mui/material/CircularProgress'
import { Controls } from 'assets/images/Controls'
import { useStationsProblemDrawer } from './StationsProblemDrawer-ViewModel'
import { Shared } from 'ui/shared'

const StationsProblemDrawer = () => {
  const vm = useStationsProblemDrawer()
  const { classes, data, isShowStationsDrawer, isLoading, onClose, onClickOpen } = vm

  return (
    <Drawer
      anchor="right"
      variant="persistent"
      open={isShowStationsDrawer}
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <div className={classes.container}>
        <div className={classes.header}>
          <Typography title={'Stations with lock problems'} variant="h3" color="primary" noWrap>
            {`Stations with lock problems: ${data.problemStations}`}
          </Typography>

          <IconButton onClick={onClose} className={classes.closeIcon} size="large">
            <Controls.CloseNotificationDrawer />
          </IconButton>
        </div>

        <div className={classes.content}>
          {isLoading && <CircularProgress className={classes.loader} size={24} />}
          <div className={classes.buttons}>
            <Shared.Button
              className={classes.button}
              width={'80%'}
              title={'Open stations'}
              onClick={onClickOpen}
              color={'primary'}
            />
          </div>
        </div>
      </div>
    </Drawer>
  )
}

export default StationsProblemDrawer
